import 'twin.macro';
import 'styled-components/macro';
import { Link } from 'react-router-dom';

import { ButtonV2 } from 'component-lib/atoms/button-v2/ButtonV2';
import { LoadingImage } from 'component-lib/atoms/LoadingImage/LoadingImage';
import { EmptyPlaceholder } from 'component-lib/molecules/placeholder/EmptyPlaceholder';
import { useFavoritesContext } from 'toy/context/Favorites';
import { useRatingsContext } from 'toy/context/Ratings';
import { SweetCard } from 'toy/molecules/sweet-card/SweetCard';
import { useSweetsQuery } from 'types/graphql-toy';

import { BackButton } from '../../atoms/back-button/BackButton';

export const Favorites = () => {
  const { items } = useFavoritesContext();
  const { loading, data: sweetsData } = useSweetsQuery();
  const { getAverageRating } = useRatingsContext();

  const favoriteItems = sweetsData?.sweets?.filter(({ id }) => items.includes(id)) ?? [];

  const mergedSweetData = favoriteItems?.map(sweet => {
    const reviewStats = getAverageRating(sweet.id);

    return {
      ...sweet,
      rating: reviewStats.average || 0,
      votes: reviewStats.reviews || 0,
    };
  });

  if (!items.length) {
    return (
      <EmptyPlaceholder
        title="You don't have any favorites items yet."
        description="Go back to the sweets list and add some items to the favorites list."
        buttons={
          <Link to="/toy-shop/sweet">
            <ButtonV2 variant="primary">Start shopping</ButtonV2>
          </Link>
        }
      />
    );
  }

  if (loading) {
    return (
      <>
        <FavoritesHeader />

        <LoadingImage />
      </>
    );
  }

  return (
    <>
      <FavoritesHeader />

      <h2 tw="display-3 mb-1">There are {items.length} favorite sweet(s)</h2>

      <div tw="grid grid-cols-4 gap-2">
        {mergedSweetData.map(sweet => (
          <SweetCard key={sweet.id} item={sweet} />
        ))}
      </div>
    </>
  );
};

const FavoritesHeader = () => (
  <div tw="flex justify-between">
    <h1 tw="display-1 mb-2">Favorites</h1>

    <BackButton />
  </div>
);
